import { setToString } from './set.utils.js';
import { iterToSet } from './transform.utils.js';
import { ROOT_CLASSNAMES } from '../constants/globals.js';

function getRootClassNames({ theme = null, standardMode = false, darkMode = false, lightMode = false } = {}, defaultClassNames = []) {
    const classNameSet = iterToSet(defaultClassNames);
    classNameSet.add(ROOT_CLASSNAMES.base);
    if (standardMode) {
        classNameSet.add(ROOT_CLASSNAMES.standardMode);
    }
    if (darkMode) {
        classNameSet.add(ROOT_CLASSNAMES.darkMode);
    }
    // if (compactMode) {
    //   classNameSet.add(ROOT_CLASSNAMES.compactMode)
    // }
    // TODO: Tokens v3 remove lightMode
    if (lightMode) {
        classNameSet.add(ROOT_CLASSNAMES.lightMode);
    }
    // TODO: Tokens v3 remove themeHoliday
    if (theme === 'holiday') {
        classNameSet.add(ROOT_CLASSNAMES.themeHoliday);
    }
    return setToString(classNameSet);
}

export { getRootClassNames };
